import React from 'react';
import RouteManager from './RouteManager';

function Body() {
  return <RouteManager />;
}

export default Body;
